<a
  class="subscription-badge"
  [ngClass]="['subscription-badge--' + plan(), 'subscription-badge--' + state()]"
  routerLink="/account"
  [queryParams]="{ tab: subscriptionTabParam }"
  [attr.title]="
    !partner() && subscription() ? ('DASHBOARD.PAID_UNTIL' | translate) + ' ' + (subscription()?.paidUntil | date) : null
  ">
  <mat-icon class="subscription-badge__icon">workspace_premium</mat-icon>
  <span class="subscription-badge__text">
    {{ partner()?.name || (planLabel() | translate) }} @if (statusLabel(); as status) {
    <span class="subscription-badge__status">· {{ status | translate }}</span>
    }
  </span>
</a>
